/* eslint-disable no-unused-vars */
const HELMET = [
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/c/c3/Helmet_Icon_White.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/c/c3/Helmet_Icon_White.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/d/df/Helmet_Icon_Light_Green.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/1/15/Helmet_Icon_Green.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/f/fe/Helmet_Icon_Light_Blue.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/9/93/Helmet_Icon_Indigo.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/4/4d/Helmet_Icon_Dark_Purple.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/3/37/Helmet_Icon_Orange.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/2/24/Helmet_Icon_Red.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/8/85/Helmet_Icon_Sky_Blue.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/6/65/Helmet_Icon_Yellow.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/1/16/Helmet_Icon_Light_Grey.png",
];

const CHEST = [
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/2/28/Chest_Icon_White.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/2/28/Chest_Icon_White.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/0/08/Chest_Icon_Light_Green.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/4/48/Chest_Icon_Green.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/6/60/Chest_Icon_Light_Blue.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/d/d5/Chest_Icon_Indigo.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/6/63/Chest_Icon_Dark_Purple.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/9/9a/Chest_Icon_Orange.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/7/72/Chest_Icon_Red.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/d/dd/Chest_Icon_Sky_Blue.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/9/94/Chest_Icon_Yellow.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/c/cb/Chest_Icon_Light_Grey.png",
];

const GLOVES = [
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/b/bf/Arm_Icon_White.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/b/bf/Arm_Icon_White.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/d/d9/Arm_Icon_Light_Green.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/1/19/Arm_Icon_Green.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/6/6b/Arm_Icon_Light_Blue.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/2/26/Arm_Icon_Indigo.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/d/d2/Arm_Icon_Dark_Purple.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/5/5c/Arm_Icon_Orange.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/e/e4/Arm_Icon_Red.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/f/f9/Arm_Icon_Sky_Blue.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/3/3a/Arm_Icon_Yellow.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/4/40/Arm_Icon_Light_Grey.png",
];

const WAIST = [
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/2/22/Waist_Icon_White.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/2/22/Waist_Icon_White.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/3/3d/Waist_Icon_Light_Green.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/1/1d/Waist_Icon_Green.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/1/17/Waist_Icon_Light_Blue.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/1/11/Waist_Icon_Indigo.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/2/2d/Waist_Icon_Dark_Purple.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/a/ad/Waist_Icon_Orange.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/4/4d/Waist_Icon_Red.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/3/3f/Waist_Icon_Sky_Blue.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/3/3b/Waist_Icon_Yellow.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/7/7d/Waist_Icon_Light_Grey.png",
];

const LEGS = [
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/c/c4/Leg_Icon_White.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/c/c4/Leg_Icon_White.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/f/fd/Leg_Icon_Light_Green.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/d/d3/Leg_Icon_Green.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/c/c8/Leg_Icon_Light_Blue.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/b/bf/Leg_Icon_Indigo.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/1/1e/Leg_Icon_Dark_Purple.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/a/aa/Leg_Icon_Orange.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/5/5e/Leg_Icon_Red.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/a/ab/Leg_Icon_Sky_Blue.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/7/73/Leg_Icon_Yellow.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/9/93/Leg_Icon_Light_Grey.png",
];

const TALISMAN = [
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/a/ad/Talisman_Icon_White.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/a/ad/Talisman_Icon_White.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/c/cb/Talisman_Icon_Light_Green.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/4/40/Talisman_Icon_Green.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/7/70/Talisman_Icon_Light_Blue.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/8/89/Talisman_Icon_Indigo.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/b/bd/Talisman_Icon_Dark_Purple.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/4/4d/Talisman_Icon_Orange.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/1/18/Talisman_Icon_Red.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/f/f1/Talisman_Icon_Sky_Blue.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/a/a0/Talisman_Icon_Yellow.png",
  "https://static.wikia.nocookie.net/fanonmonsterhunter/images/2/2e/Talisman_Icon_Light_Grey.png",
];

export function getArmorIcon(type, rarity) {
  switch (type) {
    case "head":
      return HELMET[rarity - 1];
    case "chest":
      return CHEST[rarity - 1];
    case "gloves":
      return GLOVES[rarity - 1];
    case "waist":
      return WAIST[rarity - 1];
    case "legs":
      return LEGS[rarity - 1];
    case "charm":
      return TALISMAN[rarity - 1];
    default:
      return "";
  }
}

const GS = "great-sword";
const LS = "long-sword";
const SnS = "sword-and-shield";
const DB = "dual-blades";
const HAMMER = "hammer";
const HH = "hunting-horn";
const LANCE = "lance";
const GL = "gunlance";
const SA = "switch-axe";
const CB = "charge-blade";
const IG = "insect-glaive";
const LBG = "light-bowgun";
const HBG = "heavy-bowgun";
const BOW = "bow";

export function getWeaponIcon(type, rarity) {
  let renamedType;
  switch (type) {
    case GS:
      renamedType = "greatsword";
      break;
    case LS:
      renamedType = "longsword";
      break;
    case SnS:
      renamedType = "sword-shield";
      break;
    default:
      renamedType = type;
      break;
  }

  if (type === IG && rarity < 9)
    return `https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/rare-${rarity}-insect-glaive-mhw_tree_tree.png`;
  else if (rarity < 9)
    return `https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/rare-${rarity}-${renamedType}-mhw_tree.png`;
  else
    return `https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/rare-${rarity}-mhw-${renamedType}-wiki.png`;
}

const elementTypes = new Map();
elementTypes.set(
  "fire",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/fireblight.png"
);
elementTypes.set(
  "water",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/waterblight.png"
);
elementTypes.set(
  "thunder",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/thunderblight.png"
);
elementTypes.set(
  "ice",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/Iceblight.png"
);
elementTypes.set(
  "dragon",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/DragonBlight.png"
);
elementTypes.set(
  "poison",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/Poison.png"
);
elementTypes.set(
  "paralysis",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/Paralysis.png"
);
elementTypes.set(
  "sleep",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/Sleep.png"
);
elementTypes.set(
  "blast",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/Blastblight.png"
);

export function getElementType(type) {
  return elementTypes.get(type);
}

export function getSlotIcon(level) {
  switch (level) {
    case 1:
      return "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/gem_level_1.png";
    case 2:
      return "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/gem_level_2.png";
    case 3:
      return "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/gem_level_3.png";
    case 4:
      return "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/decoration_level_4_mhw_wiki.png";
    default:
      return "";
  }
}

export function getDecorationIcon(level) {
  switch (level) {
    case 1:
      return "https://cdn.kiranico.net/file/mhworld-kiranico/images/itm/icon/66_0.png";
    case 2:
      return "https://cdn.kiranico.net/file/mhworld-kiranico/images/itm/icon/67_0.png";
    case 3:
      return "https://cdn.kiranico.net/file/mhworld-kiranico/images/itm/icon/68_0.png";
    case 4:
      return "https://cdn.kiranico.net/file/mhworld-kiranico/images/itm/icon/72_0.png";
    default:
      return "";
  }
}

const statIcons = new Map();
statIcons.set(
  "attack",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/mhw-attack.png"
);
statIcons.set(
  "sharpness",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/mhw-sharpness.png"
);
statIcons.set(
  "affinity",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/mhw-affinity.png"
);
statIcons.set(
  "element",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/mhw-element-damage.png"
);
statIcons.set(
  "elderseal",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/elderseal_icon.png"
);
statIcons.set(
  "decoration",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/mhw-decoration_s.png"
);
statIcons.set(
  "defense",
  "https://monsterhunterworld.wiki.fextralife.com/file/Monster-Hunter-World/mhw-defense_s.png"
);

export const rarityColor = [
  "white",
  "white",
  "rgb(162,187,70)",
  "rgb(89,153,106)",
  "rgb(156,223,248)",
  "rgb(103,100,215)",
  "rgb(114,29,124)",
  "rgb(198,121,74)",
  "rgb(190,66,74)",
  "rgb(79,210,245)",
  "rgb(203,165,82)",
  "rgb(212,237,249)",
];

export function getStatIcon(type) {
  return statIcons.get(type);
}
